import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AssetSelect from '../../components/assetselect';
import ConfirmAutomation from './confirmautomation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

class CreateAutomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { user, errors, success } = this.props;
    const {
      assetDeposit,
      assetBuy,
      assetBuyList,
      assetDepositList,
      removeBuy,
      addBuy,
      percentChange,
      buyChange,
      depositChange,
      isOfType,
      newAutomationComplete,
      handleCreateAutomation,
      toggleModal,
      modalComponent,
      autoErr,
      automationDisabled,
    } = this.props;

    let buyLoop;
    let sliderLoop;
    let actionLoop;

    if (assetBuy && assetBuy.length) {
      buyLoop = assetBuy.map((item, index) => {

        let isLast;
        if (
          (assetBuy.length === 1) ||
          (index === (assetBuy.length - 1))
        ) {
          isLast = true;
        }

        const useId = item.id;

        return (
          <div key={index}>
            <div className="ap-da-wrap">
              <AssetSelect
                key={index}
                onChange={buyChange}
                curVal={item.asset || ''}
                options={assetBuyList}
                optName="name"
                optVal="asset"
                useId={useId}
                assetSel
                disabled={!assetDeposit}
              />
              {isLast ? (
                <>
                  {assetBuy.length > 1 ? (
                    <div className="ap-da-action slider-sm">
                      <button
                        className="vlt-circle-btn vlt-circle-btn--close"
                        onClick={() => removeBuy(useId)}
                        disabled={!assetDeposit}
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={faMinus}
                          />
                        </span>
                      </button>
                      {index <= 4 ? (
                        <button
                          className="vlt-circle-btn"
                          onClick={() => addBuy()}
                          disabled={!assetDeposit}
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={faPlus}
                            />
                          </span>
                        </button>
                      ) : (
                        null
                      )}
                    </div>
                  ) : (
                    <div className="ap-da-action slider-sm">
                      <button
                        className="vlt-circle-btn"
                        onClick={() => addBuy()}
                        disabled={!assetDeposit}
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={faPlus}
                          />
                        </span>
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <div className="ap-da-action slider-sm">
                  <button
                    className="vlt-circle-btn vlt-circle-btn--close"
                    onClick={() => removeBuy(useId)}
                    disabled={!assetDeposit}
                  >
                    <span>
                      <FontAwesomeIcon
                        icon={faMinus}
                      />
                    </span>
                  </button>
                </div>
              )}
            </div>
            <div className="slider-con slider-sm">
              <div className="slider-fill-wrap">
                <div
                  className="slider-bg"
                />
                <div
                  className="slider-fill"
                  style={{width: `${item.percentage + 10 || 0}%`}}
                />
                <input
                  onChange={percentChange}
                  type="range"
                  min="0"
                  max="100"
                  step="25"
                  value={item.percentage || 0}
                  className="slider"
                  id={useId}
                  disabled={!assetDeposit}
                  list="percentageTicks"
                />
              </div>
              <div className="slider-ticks">
                <div>
                  0%
                </div>
                <div>
                  25%
                </div>
                <div>
                  50%
                </div>
                <div>
                  75%
                </div>
                <div>
                  100%
                </div>
              </div>
            </div>
          </div>
        );
      });

      sliderLoop = assetBuy.map((item, index) => {
        const useId = item.id;
        return (
          <div key={index}>
            <div className="slider-con">
              <div className="slider-fill-wrap">
                <div
                  className="slider-bg"
                />
                <div
                  className="slider-fill"
                  style={{width: `${item.percentage + 10 || 0}%`}}
                />
                <input
                  onChange={percentChange}
                  type="range"
                  min="0"
                  max="100"
                  step="25"
                  value={item.percentage || 0}
                  className="slider"
                  id={useId}
                  disabled={!assetDeposit}
                  list="percentageTicks"
                />
              </div>
              <div className="slider-ticks">
                <div>
                  0%
                </div>
                <div>
                  25%
                </div>
                <div>
                  50%
                </div>
                <div>
                  75%
                </div>
                <div>
                  100%
                </div>
              </div>
            </div>
          </div>
        );
      });

      actionLoop = assetBuy.map((item, index) => {

        let isLast;
        if (
          (assetBuy.length === 1) ||
          (index === (assetBuy.length - 1))
        ) {
          isLast = true;
        }

        const useId = item.id;

        return (
          <div key={index}>
            {isLast ? (
              <>
                {assetBuy.length > 1 ? (
                  <div className="ap-da-action">
                    <button
                      className="vlt-circle-btn vlt-circle-btn--close"
                      onClick={() => removeBuy(useId)}
                      disabled={!assetDeposit}
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={faMinus}
                        />
                      </span>
                    </button>
                    <button
                      className="vlt-circle-btn"
                      onClick={() => addBuy()}
                      disabled={!assetDeposit}
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={faPlus}
                        />
                      </span>
                    </button>
                  </div>
                ) : (
                  <div className="ap-da-action">
                    <button
                      className="vlt-circle-btn"
                      onClick={() => addBuy()}
                      disabled={!assetDeposit}
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={faPlus}
                        />
                      </span>
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="ap-da-action">
                <button
                  className="vlt-circle-btn vlt-circle-btn--close"
                  onClick={() => removeBuy(useId)}
                  disabled={!assetDeposit}
                >
                  <span>
                    <FontAwesomeIcon
                      icon={faMinus}
                    />
                  </span>
                </button>
              </div>
            )}
          </div>
        );
      });

    }

    return (
      <div className="cell panel small-12 medium-12 large-12">
        <div className="panel-label">
          Trading Automation
        </div>
        <p className="panel-sub mute">
          Automatically perform trades when depositing your chosen asset.
        </p>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-5">
            <div className="auto-picker">
              <div className="ap-drop">
                <p>When I deposit...</p>
                <AssetSelect
                  onChange={depositChange}
                  curVal={assetDeposit || ''}
                  options={assetDepositList}
                  optName="name"
                  optVal="asset"
                  useId="assetDeposit"
                  assetSel
                />
              </div>
              <div className="ap-arrow">
                <FontAwesomeIcon
                  icon={faArrowRight}
                  size="lg"
                />
              </div>
              <div className="ap-drop">
                <p>I want to buy...</p>

                <div className="ap-drop-assets">
                  {buyLoop}
                </div>
              </div>
            </div>
          </div>

          <div className="cell small-12 medium-12 large-5 slider-lg">
            <div className="auto-slider">
              <div className="as-slider">
                {sliderLoop}
              </div>
              <div className="as-actions">
                {actionLoop}
              </div>
            </div>
          </div>

          <div className="cell small-12 medium-12 large-2">
            <div className="auto-action">
              <button
                className="vlt-btn"
                disabled={!newAutomationComplete || automationDisabled}
                onClick={() => toggleModal(
                  <ConfirmAutomation
                    toggleModal={toggleModal}
                    modalComponent={modalComponent}
                    assetDeposit={assetDeposit}
                    assetBuy={assetBuy}
                    handleCreateAutomation={handleCreateAutomation}
                  />
                  , false
                )}
              >
                <span>
                  Save
                </span>
              </button>
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            { automationDisabled && (
              <div className="otp-err">
                {autoErr}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  automations: state.automation.automations,
  loading: state.automation.loading,
  errors: state.automation.errors,
  success: state.automation.success,
});

export default withRouter(connect(mapStateToProps)(CreateAutomation));
